import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { RefreshCcw, ShieldAlert, Lock } from 'lucide-react';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-20 px-4 bg-navy-900" data-id="element-183">
      <div className="max-w-4xl mx-auto" data-id="element-184">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} data-id="element-185">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl font-bold text-center text-white mb-16" data-id="element-186">
            La trampa silenciosa que te está{' '}
            <span className="text-gold-500" data-id="element-187">robando la tranquilidad</span>
          </motion.h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-188">
            <motion.div variants={itemVariants} className="bg-navy-800 p-8 rounded-xl border border-navy-700 hover:border-gold-500/30 transition-colors" data-id="element-189">
              <RefreshCcw className="text-gold-500 mb-6" size={40} data-id="element-190" />
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-191">
                La "Bicicleta" Infinita
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-192">
                Llevas meses (o quizás años) haciendo la "bicicleta". Sacas un
                avance en efectivo de una tarjeta para pagar la cuota de la
                otra. El banco te ofrece "refinanciar" con una cuota más baja,
                pero cuando miras la letra chica, te acaban de amarrar por 4
                años más con un interés del 35%.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-navy-800 p-8 rounded-xl border border-navy-700 hover:border-gold-500/30 transition-colors" data-id="element-193">
              <ShieldAlert className="text-gold-500 mb-6" size={40} data-id="element-194" />
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-195">
                El Miedo Constante
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-196">
                Vives con el miedo constante a que un receptor judicial toque tu
                puerta en Maipú, Puente Alto o Viña, y proyecte esa sombra de
                vergüenza frente a tus vecinos. Sientes que tu nombre en DICOM
                es una mancha que nunca se va a borrar.
              </p>
            </motion.div>

            <motion.div variants={itemVariants} className="bg-navy-800 p-8 rounded-xl border border-navy-700 hover:border-gold-500/30 transition-colors" data-id="element-197">
              <Lock className="text-gold-500 mb-6" size={40} data-id="element-198" />
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-199">
                Pérdida de Libertad
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-200">
                El sueño de la casa propia o de un auto nuevo se alejó para
                siempre. Lo peor no es la deuda, es la pérdida de libertad.
                Verse obligado a decir que "no" a tus hijos por culpa de un
                interés rotativo que parece un robo legalizado.
              </p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}